import { OdinIcon } from '@myosh/odin-components';
import { useFileDownload } from '../../../../hooks/use-file-download';
import clsx from 'clsx';
import type { MouseEvent } from 'react';

interface AttachmentListItemProps {
  name: string;
  url: string;
  lastModified: string;
  id: string;
}

export default function AttachmentListItem({ name, url, lastModified, id }: AttachmentListItemProps) {
  const { handleDownload, isDownloading } = useFileDownload({
    fileId: id,
    fileName: name,
    currentUrl: url,
  });

  const handleClick = async (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    await handleDownload();
  };

  return (
    <a
      className={clsx('mb-1 flex w-full cursor-pointer', { 'pointer-events-none opacity-60': isDownloading })}
      href={isDownloading ? undefined : url}
      download={name}
      onClick={handleClick}
      aria-disabled={isDownloading}
      tabIndex={isDownloading ? -1 : 0}
    >
      <OdinIcon icon="FileText" className="mr-1 mt-0.5" />
      <div>
        <div className="mb-0.25 text-sm font-bold">{name}</div>
        <div className="text-xs">{lastModified}</div>
      </div>
    </a>
  );
}
